import Vue from 'vue'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime' // импорт плагина
import cookies from 'vue-cookies'

const getLanguageCookies = cookies.get('languageSelect')

if (getLanguageCookies) {
  const locale = getLanguageCookies && getLanguageCookies.locale.split('-')[0]
  require('dayjs/locale/' + locale)
  dayjs.locale(locale)
  dayjs.extend(relativeTime)

  Vue.prototype.$dayjs = dayjs
}
